import { createAction } from '@reduxjs/toolkit';

export const twitterUpdateId = createAction('twitter/updateId');
export const twitterUpdateUID = createAction('twitter/updateUID');
export const twitterUpdateSID = createAction('twitter/updateSID');
export const twitterUpdateIsAdded = createAction('twitter/updateIsAdded');
export const twitterUpdateIsActive = createAction('twitter/updateIsActive');

export const twitterStore = createAction('twitter/store');
export const twitterClear = createAction('twitter/clear');

export const twitterUpdateRequest = createAction('twitter/updateRequest');
export const twitterUpdateError = createAction('twitter/updateError');
export const twitterUpdateStore = createAction('twitter/updateStore');

export const twitterUpdateURL = createAction('twitter/updateURL');
export const twitterUpdateEmbedCode = createAction('twitter/updateEmbedCode');

export const twitterUpdateHeadingTitle = createAction('twitter/updateHeadingTitle');
export const twitterUpdateHeadingDescription = createAction('twitter/updateHeadingDescription');
export const twitterUpdateHeadingTextAlign = createAction('twitter/updateHeadingTextAlign');
export const twitterUpdateHeadingImage = createAction('twitter/updateHeadingImage');
export const twitterUpdateHeadingDivider = createAction('twitter/updateHeadingDivider');

export const twitterUpdateSectionIsBackground = createAction('twitter/updateSectionIsBackground');
export const twitterUpdateSectionTextColor = createAction('twitter/updateSectionTextColor');
export const twitterUpdateSectionBackgroundColor = createAction('twitter/updateSectionBackgroundColor');
export const twitterUpdateSectionOpacity = createAction('twitter/updateSectionOpacity');
export const twitterUpdateSectionIsFullWidth = createAction('twitter/updateSectionIsFullWidth');
export const twitterUpdateSectionShadow = createAction('twitter/updateSectionShadow');
export const twitterUpdateSectionShadowColor = createAction('twitter/updateSectionShadowColor');
export const twitterUpdateSectionPadding = createAction('twitter/updateSectionPadding');
export const twitterUpdateSectionMargin = createAction('twitter/updateSectionMargin');
export const twitterUpdateSectionBackgroundType = createAction('twitter/updateSectionBackgroundType');
export const twitterUpdateSectionBackgroundImage = createAction('twitter/updateSectionBackgroundImage');
export const twitterUpdateSectionGradientColor1 = createAction('twitter/updateSectionGradientColor1');
export const twitterUpdateSectionGradientColor2 = createAction('twitter/updateSectionGradientColor2');
export const twitterUpdateSectionGradientDirection = createAction('twitter/updateSectionGradientDirection');
export const twitterUpdateSectionGradientOffset = createAction('twitter/updateSectionGradientOffset');
export const twitterUpdateSectionBorder = createAction('twitter/updateSectionBorder');
export const twitterUpdateSectionBorderColor = createAction('twitter/updateSectionBorderColor');
export const twitterUpdateSectionShadowBorderColor = createAction('twitter/updateSectionShadowBorderColor');
export const twitterUpdateSectionShape = createAction('twitter/updateSectionShape');
